import styled, { css } from "styled-components";

export const Wrraper = styled.div``;

export const ModalContainer = styled.div`
  position: fixed;
  inset: 0 0 0 0;
  z-index: -1;
  transition: 0.3s;
  visibility: hidden;
  z-index: ${(props) => (props.active ? "400" : "0")};
  visibility: ${(props) => (props.active ? "visible" : "0")};
`;
export const ModalContainerBg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 1;
  transition: 0.2s;
  opacity: 0;
  background: rgba(31, 44, 81, 0.65);
  visibility: hidden;

  ${({ $active }) =>
    $active
      ? css`
          visibility: visible;
          opacity: 1;
        `
      : ""};
`;
export const ModalContainerContent = styled.div`
  position: absolute;
  left: 50%;
  transform: ${(props) =>
    props.active ? "translate(-50%, -50%)" : " translate(-50%)"};
  background: #fff;
  box-shadow: 8px 10px 10px #ccc;

  transition: 0.15s;
  padding: 24px 0px;
  width: 100%;
  bottom: 0;

  border-radius: 20px 20px 0px 0px;

  max-width: 500px;
  max-height: 90vh;
  overflow: auto;
  @media (max-width: 300px) {
    width: 300px !important;
  }
`;
export const ModalContainerHead = styled.div`
  justify-content: flex-end;
`;
export const ModalContainerHeadTitle = styled.div`
  margin-bottom: 12px;
`;

export const TitleModal = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
`;

export const Title = styled.p`
  color: #4495b2;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 180%;
`;

export const WrapperVerify = styled.div`
  padding: 12px 24px;
  display: flex;
  /* align-items: end; */
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
export const Lable = styled.label`
  color: #2a3e64;
  font-size: 14px;
  font-weight: 600;
`;
export const Input = styled.input`
  margin: 2px 0px;
  padding: 10px;
  border-radius: 7px;
  border: 1px solid #dde5ed;
  width: 100%;
`;
export const BtnConfirmation = styled.button`
  border-radius: 5px;
  background: #eaf9f8;
  color: #4495b2;
  border: none;
  padding: 12px 9px;
  width: 50%;
  margin-inline-start: 4px;
  text-align: center;
`;
export const BtnClose = styled.button`
  border: none;
  background-color: transparent;
`;
export const CloseSvg = styled.svg`
  fill: #4495b2 !important;
`;

export const Suject = styled.div`
  color: #2a3e64;
  font-size: 14px;
  font-weight: 500;

  text-align: start;
  margin: 32px 24px 40px;
`;
export const BtnWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const NoBtn = styled.button`
  border-radius: 10px;
  background: #eaf9f8;
  width: 327px;
  height: 46px;
  border: none;
  margin-bottom: 12px;
  color: #4495b2;
  @media (max-width: 327px) {
    width: 250px;
  }
`;
export const YesBtn = styled.button`
  border-radius: 10px;
  border: none;
  background: var(
    --linear,
    linear-gradient(164deg, #5ed2d2 0%, #5ed2b7 58.45%)
  );
  box-shadow: 0px 4px 10px 0px rgba(95, 211, 183, 0.4);
  width: 327px;
  height: 46px;
  flex-shrink: 0;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 327px) {
    width: 250px;
  }
`;

export const Requierd = styled.span``;
export const VerfiyContainer = styled.div``;

export const InputField = styled.input`
  margin: 2px 0px;
  padding: 10px;
  border-radius: 7px;
  border: 1px solid #dde5ed;
`;
export const ErrorMessage = styled.span`
  color: red;
  font-size: 12px;
`;

//------------------------------------

export const BgHeader = styled.section`
  background-repeat: no-repeat;
  background-size: cover;
  height: 25vh;
`;
export const ContentHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
`;

export const Notic = styled.p`
  color: #fff;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
`;

export const Container = styled.div`
  background-color: #fff;
  border-radius: 16px 16px 0px 0px;
  margin-top: -15px;
  padding: 20px 24px;
  margin-bottom: 20px;
  @media (max-width: 327px) {
    padding: 20px 16px;
  }
`;

export const InformationTitle = styled.h1`
  color: #4495b2;
  font-size: 20px;
  font-weight: 700;
  @media (max-width: 327px) {
    text-align: center;
  }
`;

export const FormWrapper = styled.div``;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 15px 0px;
`;
